export async function downloadStatsCsv({ mode, token }) {
  const resp = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/exportStatsCSV`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ statType: mode }),
    }
  );

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to download CSV");
  }

  const blob = await resp.blob();
  const disposition = resp.headers.get("Content-Disposition");
  let filename = `stats_${mode}.csv`;
  if (disposition) {
    const match = /filename="?([^";\n]+)"?/i.exec(disposition);
    if (match?.[1]) filename = match[1];
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
